module.exports = __webpack_public_path__ + "img/blue_ic_myorders.a1805dd1.svg";